// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"2ede1a83","488":"c764514c","582":"fa469db1"}[chunkId] + ".chunk.js";
};